export default "__VITE_ASSET__DOgFnrn2__"